import styled, { keyframes } from "styled-components";
import { useMediaQuery } from "../../../../utils/hooks";
import Marquee from "react-fast-marquee";
import { useTranslation } from "react-i18next";

function InviteMarquee() {
  const isMobile = useMediaQuery("(max-width: 992px)");
  const { t } = useTranslation();
  return (
    <InviteMarqueeWrapper>
      <MarqueeContainer>
        <Marquee className="marquee">
          {/* {Array.from({ length: 5 }).map((_, index) => ( */}
            <p className='marquee-text'>
              {t("invite_marquee_update")}
            </p>
          {/* ))} */}
        </Marquee>
      </MarqueeContainer>
    </InviteMarqueeWrapper>
  );
}

export default InviteMarquee;

const InviteMarqueeWrapper = styled.div`
  position: fixed;
  bottom: 92px;
  left: 0;
  right: 0;
  z-index: 99;
  transform: translateY(0);
  pointer-events: none;
  border-top-left-radius: 14px;
  border-top-right-radius: 14px;
  max-height: 43px;
  max-width: 1171px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);

  @media (min-width: 992px) {
    bottom: 0;
    transform: translateY(0);
    position: sticky;
  }
`;

const marquee = keyframes`
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-50%);
  }
`;

const MarqueeContainer = styled.div`
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  background: linear-gradient(180deg, #ff7029 0%, #ff992f 100%);
  padding: 10px 0;
  margin-bottom: 12px;
  position: relative;
  /* border: 2px solid #b03214; */
  /* border-top-left-radius: 14px; */
  /* border-top-right-radius: 14px; */
  z-index: 2;

  .marquee {
    /* display: inline-block; */
    /* animation: ${marquee} 40s linear infinite; */
    /* width: max-content; */
    overflow-x: unset;
    .marquee-text {
      color: white;
      display: inline-block;
      margin-right: 40px;
      font-size: 12px;
    }
  }
`;

// const Marquee = styled.div`
  
// `;
